module.exports = __webpack_public_path__ + "static/media/shiftshave-4.22cd86f4.jpg";